import { createAction } from 'redux-actions';

import * as API from 'api/rest';
import { getLDAPToken as getLDAPTokenCall } from 'api/ecosystemUsers';
import { handlePromises } from 'utils';
import { OBJECT_TYPES } from 'enum/object';
import * as ACTION_TYPES from './action-types';

export function createPolicyObject({ object, field }) {
  return {
    type: ACTION_TYPES.CREATE_POLICY_OBJECT,
    payload: {
      object,
      field,
    },
  };
}
export function generateTokenStarted() {
  return {
    type: ACTION_TYPES.GENERATE_TOKEN_REQUESTED,
  };
}
export function generateTokenSuccess() {
  return {
    type: ACTION_TYPES.GENERATE_TOKEN_SUCCESS,
  };
}
export function generateTokenFailed(err) {
  return {
    type: ACTION_TYPES.GENERATE_TOKEN_FAILURE,
    payload: {
      message: err,
    },
  };
}

export function generateImageStarted(payload) {
  return {
    type: ACTION_TYPES.GENERATE_IMAGE_STARTED,
    payload,
  };
}
export function generateImageFailed(payload) {
  return {
    type: ACTION_TYPES.GENERATE_IMAGE_FAILURE,
    payload,
  };
}
export const generateImageSuccess = createAction(ACTION_TYPES.GENERATE_IMAGE_SUCCESS);

export function thingConfStarted() {
  return {
    type: ACTION_TYPES.THING_CONF_REQUESTED,
  };
}
export function thingConfSuccess(configs) {
  return {
    type: ACTION_TYPES.THING_CONF_SUCCESS,
    payload: {
      configs,
    },
  };
}
export function thingConfFailed(err) {
  return {
    type: ACTION_TYPES.THING_CONF_FAILURE,
    payload: {
      message: err,
    },
  };
}

export function regenPSKStarted() {
  return {
    type: ACTION_TYPES.REGEN_PSK_REQUESTED,
  };
}
export function regenPSKSuccess(payload) {
  return {
    type: ACTION_TYPES.REGEN_PSK_SUCCESS,
    payload,
  };
}
export function regenPSKFailed(err) {
  return {
    type: ACTION_TYPES.REGEN_PSK_FAILURE,
    payload: {
      message: err,
    },
  };
}

export const updateThingToken = createAction(ACTION_TYPES.UPDATE_THING_TOKEN);

export function getLDAPTokenSuccess(payload) {
  return {
    type: ACTION_TYPES.GET_LDAP_TOKEN_SUCCESS,
    payload,
  };
}
export function getLDAPTokenFailure(err) {
  return {
    type: ACTION_TYPES.GET_LDAP_TOKEN_FAILURE,
    payload: {
      message: err,
    },
  };
}
export const getLDAPToken = () => async (dispatch, getState) => {
  dispatch({ type: ACTION_TYPES.GET_LDAP_TOKEN });
  const globalState = getState();
  const customerUUID = globalState.customers.currentCustomer.uuid;
  const ecosystemUUID = globalState.ecosystems.currentEcosystem.uuid;
  const userUUID = globalState.user.uuid;

  try {
    const { token } = await getLDAPTokenCall({
      customerUUID,
      ecosystemUUID,
      userUUID,
    });
    dispatch(getLDAPTokenSuccess({ ecosystemUUID, token }));
  } catch (error) {
    dispatch(getLDAPTokenFailure(error));
  }
};

export const setInitialObjectLoaded = createAction(ACTION_TYPES.SET_INITIAL_OBJECT_LOADED);

export const getBasicObjects =
  ({ customerUUID, ecosystemUUID, extra = [] }) =>
  async (dispatch, getState) => {
    try {
      const { groups } = getState().ecosystems.dictionaries;

      dispatch({ type: ACTION_TYPES.GET_BASIC_OBJECTS_REQUESTED });
      const customer = { uuid: customerUUID };
      const parmas = { customer, ecosystem: ecosystemUUID };

      const scopesString = [
        'default',
        'public',
        'any-public',
        'external-public',
        'private',
        'any-private',
        'external-private',
      ].join(',');
      const [things, gateways, addresses] = await handlePromises(
        [
          API.fetchObjects({ ...parmas, type: OBJECT_TYPES.THING }),
          API.fetchObjects({ ...parmas, type: OBJECT_TYPES.GATEWAY }),
          API.fetchObjects({
            ...parmas,
            type: OBJECT_TYPES.ADDRESS,
            payload: {
              params: { scope: scopesString },
            },
          }),
        ],
        [[], [], []],
      );
      let servers = [];
      if (extra.includes('server')) {
        servers = await API.fetchObjects({ ...parmas, type: OBJECT_TYPES.SERVER });
      }

      const objects = {
        things: things.map((thing) => ({
          ...thing,
          profileGroup: groups.find((group) => group.uuid === thing.profileGroup),
        })),
        gateways,
        addresses,
        servers,
      };

      dispatch({ type: ACTION_TYPES.GET_BASIC_OBJECTS_SUCCESS, payload: { ecosystemUUID, objects } });

      return objects;
    } catch (err) {
      dispatch({ type: ACTION_TYPES.GET_BASIC_OBJECTS_FAILURE, payload: { message: err } });
      return { things: [], gateways: [], addresses: [] };
    }
  };

export const getAddressObjects =
  ({ customerUUID, ecosystemUUID }) =>
  async (dispatch) => {
    try {
      dispatch({ type: ACTION_TYPES.GET_BASIC_OBJECTS_REQUESTED });
      const addresses = await API.fetchObjects({
        customer: { uuid: customerUUID },
        ecosystem: ecosystemUUID,
        type: OBJECT_TYPES.ADDRESS,
      });

      dispatch({ type: ACTION_TYPES.GET_BASIC_OBJECTS_SUCCESS, payload: { ecosystemUUID, objects: { addresses } } });
    } catch (err) {
      dispatch({ type: ACTION_TYPES.GET_BASIC_OBJECTS_FAILURE, payload: { message: err } });
    }
  };

export const setThings = createAction(ACTION_TYPES.SET_THINGS);
export const createThing = createAction(ACTION_TYPES.CREATE_THING);
export const updateThing = createAction(ACTION_TYPES.UPDATE_THING);
export const deleteThing = createAction(ACTION_TYPES.DELETE_THING);

export const setAddresses = createAction(ACTION_TYPES.SET_ADDRESSES);
export const createAddress = createAction(ACTION_TYPES.CREATE_ADDRESS);
export const updateAddress = createAction(ACTION_TYPES.UPDATE_ADDRESS);
export const deleteAddress = createAction(ACTION_TYPES.DELETE_ADDRESS);

export const setGateways = createAction(ACTION_TYPES.SET_GATEWAYS);
export const createGateway = createAction(ACTION_TYPES.CREATE_GATEWAY);
export const updateGateway = createAction(ACTION_TYPES.UPDATE_GATEWAY);
export const deleteGateway = createAction(ACTION_TYPES.DELETE_GATEWAY);
